import { isActivePublicUser, isHoppyOrGamification } from "@util/Scripts";
import { getListExcel } from "../../../../services/api/Api";
import { Message } from "../../../BP2Components";
import { encode } from "js-base64";

export class ListScripts {
   static getBasicSerieSettings = () => {
      return [
         { label: "showListTitle", addition: true },
         { label: "showTableHeader", addition: true },
         { label: "showSerieNameHeader", addition: false },
         { label: "isListHeaderFixed", addition: false },
         { label: "showProfileFilter", addition: false },
         { label: "editableRows", addition: false },
         { label: "checkboxes", addition: false },
         { label: "isCsvDownloadable", addition: false },
         { label: "isDownloadable", addition: false },
         { label: "sendDetails", addition: false },
         { label: "separateLines", addition: false },
         { label: "showVerticalLines", addition: true },
         { label: "showHorizontalLines", addition: true },
         { label: "horizontalColumns", addition: false },
         { label: "setActionsColumnRight", addition: false },
         { label: "alignColsRight", addition: false },
         { label: "centerCols", addition: false },
         { label: "technicalSerie", addition: false },
         { label: "showDragModeSwitch", addition: false },
      ];
   };
   static handleGraphQLResponse = (query, resp) => {
      query = query.replace(/ /g, "");
      query = query.replace(/}/g, "");
      let firstSplit = query.split("(");
      let funName = firstSplit[0].substr(1);
      let response;
      if (firstSplit[1]) {
         let secondSplit = firstSplit[1].split("{");
         let params = [];
         for (let i = 0; i < secondSplit.length - 1; i++) {
            if (!secondSplit[i].includes(":")) {
               params.push(secondSplit[i]);
            }
         }
         let data = resp.data.data[funName];
         if (params.length === 0) {
            response = data;
         } else if (data === null) {
            response = [];
         } else {
            if (params.length === 1) response = data[params[0]];
            if (params.length === 2) response = data[params[0]][params[1]];
            if (params.length === 3) response = data[params[0]][params[1]][params[2]];
         }
      } else {
         response = [];
      }
      if (!response) {
         response = [];
      }
      return response;
   };
   static getRowClass = (getSerieSetting) => {
      let rowClass;
      if (isHoppyOrGamification()) {
         rowClass = "custom-selection-row";
      } else {
         rowClass = "custom-selection-row thin-rows";
      }
      if (getSerieSetting("separateLines") === true) {
         rowClass += " custom-selection-row-change";
      }
      return rowClass;
   };
   static getOnlyNotTechnicalSeries = (list) => {
      let normalSeries = [];
      list?.forEach((serie) => {
         let isTechnical = false;
         serie?.listWidgetSerieSettings?.forEach((settings) => {
            if (settings.label === "technicalSerie" && settings.addition === true) {
               isTechnical = true;
            }
         });
         if (isTechnical === false) {
            normalSeries.push(serie);
         }
      });
      return normalSeries;
   };
   static getTableClass = (bottom, props, getSerieSetting, headerPosition) => {
      let tableClass = "gx-table-responsive cs-table";
      if (props?.showMap === true && bottom === true) {
         if (
            props.listWidgetSeries &&
            this.getOnlyNotTechnicalSeries(props.listWidgetSeries).length > 1
         ) {
            tableClass += " map-table table-short";
         } else {
            tableClass += " map-table table-long";
         }
      }
      if (headerPosition === "top") {
         tableClass = "gx-table-responsive cs-table map-table table-max";
      }
      if (getSerieSetting("showVerticalLines") === false) {
         tableClass += " no-vertical-border";
      }
      if (getSerieSetting("showHorizontalLines") === false) {
         tableClass += " no-horizontal-border";
      }
      if (getSerieSetting("separateLines") === true) {
         tableClass += " custom-selection-table";
      }
      return tableClass;
   };
   static getWidgetScreenHeight = () => {
      return window.innerHeight - 230 + "px";
   };
   static getWidgetClass = (showListTitle, showMap, isListHeaderFixed) => {
      let widgetCLass = "list-widget ";
      if (showListTitle === false) {
         widgetCLass += " noTitle";
      }
      if (showMap === true) {
         widgetCLass += " map-table-widget";
      }
      if (isListHeaderFixed) {
         widgetCLass += "wrap-lines";
      }

      return widgetCLass;
   };
   static prepareDataToXLSExport = (stateCols, stateRows) => {
      let cols = [];
      stateCols.forEach((col) => {
         if (col.fixed !== "left") {
            cols.push(col.dataIndex);
         }
      });
      let rows = [cols];
      if (stateRows) {
         stateRows.forEach((row) => {
            let csvRow = [];
            cols.forEach((col) => {
               if (col !== "action") {
                  let text = "";
                  if (row[col] && typeof row[col] != "object") {
                     text = row[col].toString();
                  } else if (row[col] && row[col].value && typeof row[col] == "object") {
                     text = row[col].value.toString();
                  }
                  csvRow.push(text);
               }
            });
            rows.push(csvRow);
         });
      }
      return rows;
   };
   static exportToExcelPHP = (selectedSerieObject) => {
      Message.loading("Loading...");
      getListExcel(selectedSerieObject.listId, 1, 100000)
         .then((res) => {
            // In response we get
            const data = isActivePublicUser() ? res?.data?.getPublicList : res?.data?.default;
            if (data[0]) {
               const secureFileUrl = data[0].replace(/^http:/, "https:");
               window.open(secureFileUrl);
               Message.success("Done");
            }
         })
         .catch((err) => {
            console.log(err);
            Message.error("Error");
         })
         .finally(() => {
            Message.destroy();
         });
   };
   static switchListIdForMapNeeds = (
      listId,
      markersSerie,
      listWidgetSeries,
      mapListSerie,
      mapIndependentSerie,
      selectedSerie,
   ) => {
      let listIdToRequest = listId;
      if (
         (mapListSerie && mapListSerie !== "-" && markersSerie !== mapListSerie) ||
         (mapIndependentSerie &&
            mapIndependentSerie !== "-" &&
            mapIndependentSerie !== mapListSerie)
      ) {
         listWidgetSeries.forEach((serie) => {
            if (mapListSerie === serie.name) {
               listIdToRequest = serie.listId;
            }
            if (mapIndependentSerie === selectedSerie.name && mapIndependentSerie === serie.name) {
               listIdToRequest = serie.listId;
            }
         });
      }
      return listIdToRequest;
   };
   static handlePDF = (invoicesList) => {
      let urlArr = [];
      invoicesList.map((inv) => {
         let obj = {};
         let key1 = "url";
         let value1 = inv?.plik?.altUrl ?? inv?.plik?.altUrl1 ?? inv?.plik?.fileUrl;
         let key2 = "name";
         let value2 = inv?.plik?.name;
         let key3 = "gdtoken";
         let value3 = inv?.plik?.gdAuth?.access_token;
         obj[key1] = value1;
         obj[key2] = value2;
         obj[key3] = value3;
         return urlArr.push(obj);
      });

      let ids = [];
      if (urlArr !== undefined) {
         urlArr.forEach((url) => {
            if (url.url !== undefined) {
               let obj = {};
               let id;
               let parts = url.url.split(
                  //eslint-disable-next-line
                  /^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/,
               );
               if (url.url.indexOf("?id=") >= 0) {
                  id = parts[6].split("=")[1].replace("&usp", "");
                  return id;
               } else {
                  id = parts[5].split("/");
                  let sortArr = id.sort((a, b) => {
                     return b.length - a.length;
                  });
                  id = sortArr[0];
               }
               let key = "id";
               let value = id;
               let key2 = "name";
               let value2 = url.name;
               let key3 = "gdtoken";
               let value3 = url.gdtoken;
               obj[key] = value;
               obj[key2] = value2;
               obj[key3] = value3;
               return ids.push(obj);
            }
         });
         return ids;
      }
   };
   static createGroupedPinMarkersList = (mapMarkers, localizationFieldName) => {
      let groupedMarkers = [];
      if (mapMarkers && localizationFieldName) {
         const lCLocalizationFieldName = localizationFieldName.toLowerCase();
         mapMarkers.forEach((marker) => {
            let localization = marker[lCLocalizationFieldName];
            if (localization && localization !== "") {
               let duplicate = false;
               groupedMarkers.forEach((groupedMarker) => {
                  let groupedLocalization = groupedMarker[lCLocalizationFieldName];
                  if (groupedLocalization === localization) {
                     duplicate = true;
                     groupedMarker["group"] = true;
                  }
               });
               if (duplicate === false) {
                  marker["group"] = false;
                  groupedMarkers.push(marker);
               }
            }
         });
      }
      return groupedMarkers;
   };

   static convertValuesToSameStructure = (options, type) => {
      if (type === "sql") {
         return options.map((option) => ({
            value: option?.value || option?.label,
            label: option?.label || option?.value,
         }));
      } else {
         return options.map((option) => {
            const value = Object.keys(option)[0];
            const label = Object.values(option)[0];
            return { value, label };
         });
      }
   };

   static handleAddSorterToUrl = (widgetId, column, value) => {
      const columnAttribute = column?.attribute;
      const direction = value === "ascend" ? "ASC" : "DESC";

      const finalValue = {
         direction,
         columnAttribute,
      };

      try {
         const url = new URL(window.location);
         const currentListUrlSorters = JSON.parse(
            decodeURIComponent(url.searchParams.get("listSorters")),
         );
         // First we need to check if there even are any sorters already
         if (currentListUrlSorters) {
            // Then if there are ones for current widgetId
            if (currentListUrlSorters[widgetId]) {
               currentListUrlSorters[widgetId] = finalValue;
            } else {
               // If not we assign new object
               currentListUrlSorters[widgetId] = finalValue;
            }
            url.searchParams.set(
               "listSorters",
               encodeURIComponent(JSON.stringify(currentListUrlSorters)),
            );
            window.history.replaceState({}, "", url);
         } else {
            const sorterParams = {
               [widgetId]: finalValue,
            };
            url.searchParams.set("listSorters", encodeURIComponent(JSON.stringify(sorterParams)));
            window.history.replaceState({}, "", url);
         }
      } catch (err) {
         console.log("Error in adding sorter to URL", err);
      }
   };

   ///sorting
   static handleColumnSorter = (widgetId, column) => ({
      sortDirections: ["ascend", "descend"],
      sorter: (a, b, order) => {
         this.handleAddSorterToUrl(widgetId, column, order);
      },
   });
   static renderVisibleCols = (
      columns,
      getSerieSetting,
      renderEditableRows,
      intl,
      isHeaderListFixed,
      widgetId,
   ) => {
      let visibleCols = [];
      columns.forEach((column) => {
         column = {
            ...column,
            ...ListScripts.handleColumnSorter(widgetId, column),
         };
         if (column.dataIndex === "api_recordactions" || column.dataIndex === "api_checkbox") {
            column.sorter = false;
         }
         if (column.dataIndex === "api_checkbox") {
            column.width = 50;
         }
         if (isHeaderListFixed) {
            // TODO - to remove after list refactor
            if (column.dataIndex === "api_recordactions") {
               column.width = 100;
            } else {
               column.width = 200;
            }
         }
         if (
            column.visible === undefined ||
            column.hidden === undefined ||
            (column.visible == "1" && column.hidden == "0")
         ) {
            visibleCols.push(column);
         }
         if (column.label == "api_rowmetadata") {
            column.editable = false;
         }
         if (
            column.title === "api_instanceStatus" &&
            visibleCols.find((el) => el.label === "api_instanceStatus")
         ) {
            column.title = intl.formatMessage({ id: "boardManager.instanceStatus" });
         }
         if (
            column.title === "api_performerStatus" &&
            visibleCols.find((el) => el.label === "api_instanceStatus")
         ) {
            column.title = intl.formatMessage({ id: "boardManager.performerStatus" });
         }
      });
      // Sort visible columns in ascending order by the 'sort' field
      visibleCols.sort((a, b) => (a.sort ?? Infinity) - (b.sort ?? Infinity));
      if (
         visibleCols.find((el) => el.label === "api_rowMetaData") &&
         getSerieSetting("editableRows")
      ) {
         visibleCols.splice(1, 0, renderEditableRows());
      } else if (getSerieSetting("editableRows")) visibleCols.splice(0, 0, renderEditableRows());

      return visibleCols;
   };
   static getSerieByName = (serieName, listWidgetSeries) => {
      let searchedSerie;
      if (listWidgetSeries && listWidgetSeries[0]) {
         searchedSerie = listWidgetSeries.find((serie) => serieName == serie.name);
         if (!searchedSerie) {
            searchedSerie = listWidgetSeries[0];
         }
      }
      return searchedSerie;
   };
   static handleAddFilterToUrl = (widgetId, columnTechname, value) => {
      const hasUnsafeChars = /[\/+]/.test(value);
      const validValue = hasUnsafeChars ? "b64:" + encode(value) : value;
      try {
         const url = new URL(window.location);
         const currentListUrlFilters = JSON.parse(
            decodeURIComponent(url.searchParams.get("listFilters")),
         );
         // First we need to check if there even are any filters already
         if (currentListUrlFilters) {
            // Then if there are ones for current widgetId
            if (currentListUrlFilters[widgetId]) {
               currentListUrlFilters[widgetId][columnTechname] = validValue;
            } else {
               // If not we assign new object
               currentListUrlFilters[widgetId] = { [columnTechname]: validValue };
            }
            url.searchParams.set(
               "listFilters",
               encodeURIComponent(JSON.stringify(currentListUrlFilters)),
            );
            window.history.replaceState({}, "", url);
         } else {
            const filterParams = {
               [widgetId]: { [columnTechname]: validValue },
            };
            url.searchParams.set("listFilters", encodeURIComponent(JSON.stringify(filterParams)));
            window.history.replaceState({}, "", url);
         }
      } catch (err) {
         console.log("Error in adding filter to URL", err);
      }
   };
   static handleDeleteFilterFromUrl = (widgetId, columnTechname) => {
      try {
         const url = new URL(window.location);
         const currentListUrlFilters = JSON.parse(
            decodeURIComponent(url.searchParams.get("listFilters")),
         );
         if (currentListUrlFilters?.[widgetId]?.[columnTechname]) {
            // If there is only one filter for one widget, we can delete query entirely
            if (
               Object.keys(currentListUrlFilters)?.length === 1 &&
               Object.keys(currentListUrlFilters[widgetId])?.length === 1
            ) {
               url.searchParams.delete("listFilters");
               window.history.replaceState({}, "", url);
               // If this is the last filter of given widget, we can clear query of info of this widget
            } else if (
               Object.keys(currentListUrlFilters)?.length > 1 &&
               Object.keys(currentListUrlFilters[widgetId])?.length === 1
            ) {
               delete currentListUrlFilters[widgetId];

               url.searchParams.set(
                  "listFilters",
                  encodeURIComponent(JSON.stringify(currentListUrlFilters)),
               );
               window.history.replaceState({}, "", url);
               // In other situations, just remove the property from the object
            } else {
               delete currentListUrlFilters[widgetId][columnTechname];

               url.searchParams.set(
                  "listFilters",
                  encodeURIComponent(JSON.stringify(currentListUrlFilters)),
               );
               window.history.replaceState({}, "", url);
            }
         }
      } catch (err) {
         console.log("Error in deleting filter from URL", err);
      }
   };
   static getFilteredRows = (rows) => {
      if (rows) {
         rows?.forEach((row) => {
            if (Array.isArray(row.api_performerstatus)) {
               const performerStatus = row.api_performerstatus[0];
               row.api_performerstatus = performerStatus;
            }
         });
         return rows;
      } else {
         return [];
      }
   };
   static prepareGQLRowsAndColumns(res, intl, getColumnSearchProps) {
      const resColumns = Object.keys(res[0]);
      const columnList = resColumns.map((column) => {
         return {
            title: intl.formatMessage({ id: column }),
            dataIndex: column,
            ...getColumnSearchProps(column),
         };
      });
      const rowsWithOnlyStringValues = res.map((row) => {
         let newRow = {};
         Object.keys(row).forEach(function (key) {
            let strKey = key.toString();
            if (typeof row[strKey] === "boolean") {
               newRow[strKey] = row[strKey].toString();
            } else {
               newRow[strKey] = row[strKey];
            }
         });
         return newRow;
      });
      return {
         rows: rowsWithOnlyStringValues,
         columns: columnList,
      };
   }
   static setValueInFilter = (value, list, attr, extraSearch) => {
      if (extraSearch) {
         list[attr[0]][attr[1] + "_" + extraSearch] = {};
         list[attr[0]][attr[1] + "_" + extraSearch][attr[1]] = value;
      } else if (attr[1] === undefined) {
         list[attr[0]] = value;
      } else {
         list[attr[0]][attr[1]] = value;
      }
      return list;
   };
   static selectFilterMethod = (filterValue, list, attr, extraSearch) => {
      if (Array.isArray(filterValue)) {
         this.setValueInFilter(filterValue[0], list, attr, extraSearch);
      } else {
         this.setValueInFilter(filterValue, list, attr, extraSearch);
      }
   };
   static getLabelByTechname = (techname, columns) => {
      const column = Array.isArray(columns)
         ? columns.find((el) => el.options.techName === techname)
         : null;
      return column?.label;
   };
}
